export default __webpack_public_path__ + "static/media/choose_avatar.c62d0001.svg";